import { notEmpty } from "../../../../../utils/not-empty";

import type { Segment } from "../../../types/segment-schema";
import type { SegmentReducerState } from "../reducer/actions";

export function segmentGroupHasErrors(
  errors: SegmentReducerState<Segment>["errors"],
  groupIndex: number,
): boolean {
  const group = errors.errors?.properties?.segment_json?.properties?.segments?.items?.[groupIndex];

  return notEmpty(group);
}

export function segmentJsonHasErrors(errors: SegmentReducerState<Segment>["errors"]): boolean {
  return notEmpty(errors.errors?.properties?.segment_json);
}
